export function generateID(leadingUnderscore = false): string {
  return (leadingUnderscore ? '_' : '') + Math.random().toString(36).substr(2, 9);
}
export const generateOrderID = () => generateID(false);
